import { StoreApi, UseBoundStore, useStore } from "zustand";
import { DamselfishStoreType, damselfishStore } from "./damselfish-store";
import {
  damselfishPersistentStore,
  DamselfishPersistentStoreType,
} from "./damselfish-persistent-store";
import {
  trainingChatStore,
  TrainingChatStoreType,
} from "./training-chat-store";

export const useDamselfishStore = useStore.bind(
  null,
  damselfishStore.getStore()
) as UseBoundStore<StoreApi<DamselfishStoreType>>;

export const useDamselfishPersistentStore = useStore.bind(
  null,
  damselfishPersistentStore.getStore()
) as UseBoundStore<StoreApi<DamselfishPersistentStoreType>>;

export const useTrainingChatStore = useStore.bind(
  null,
  trainingChatStore.getStore()
) as UseBoundStore<StoreApi<TrainingChatStoreType>>;
